import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star, Calendar, Music, Utensils } from 'lucide-react';
import { Link } from 'react-router-dom';
import { data } from '../data';

const Konfirmation = () => {
  const service = data.services[1]; // Konfirmation data

  return (
    <div className="pt-0">
      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src={service.image} 
            className="w-full h-full object-cover" 
            alt="Konfirmation på GuldBoSund Konference & Event" 
          />
          <div className="absolute inset-0 bg-[#081f32]/40" />
        </div>
        
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mt-20">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2 }}
            className="text-5xl md:text-7xl font-light mb-6 uppercase tracking-wider"
          >
            Konfirmation
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 0.2 }}
            className="text-xl md:text-2xl font-light"
          >
            En uforglemmelig dag for konfirmanden og familien
          </motion.p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-4xl font-light text-gray-900 mb-8 uppercase tracking-wider">Fejr den store dag i lyse rammer</h2>
              <div className="prose prose-lg text-gray-600 space-y-6">
                <p>
                  Konfirmationen er en af livets store milepæle. Hos GuldBoSund Konference & Event skaber vi rammerne for en fest, som både konfirmanden og gæsterne vil mindes med glæde.
                </p>
                <p>
                  Vores lokaler er moderne, lyse og har direkte adgang til vores smukke udeområder, hvor der er masser af plads til leg, afslapning og smukke billeder ved vandet. Vi sammensætter en menu, der appellerer til både store og små, altid med fokus på de bedste råvarer.
                </p>
              </div>

              <div className="mt-10">
                <p className="text-xs font-medium uppercase tracking-[0.24em] text-[#081f32]/60 mb-3">Personligt tilbud</p>
                <h3 className="text-2xl md:text-3xl font-medium leading-snug text-[#081f32]">
                  Vi skræddersyer og laver gerne et tilbud helt efter jeres ønsker og behov.
                </h3>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="bg-[#f8f9fa] p-10 rounded-3xl border border-gray-100 shadow-xl relative overflow-hidden"
            >
              <div className="relative z-10">
                <h3 className="text-2xl font-light text-[#081f32] mb-6 uppercase tracking-widest">Konfirmationspakke</h3>
                <div className="flex items-baseline gap-2 mb-8">
                  <span className="text-5xl font-light text-[#081f32]">{service.price}</span>
                  <span className="text-gray-500 font-light">kr. pr. kuvert</span>
                </div>
                <p className="text-gray-500 font-light mb-6 uppercase tracking-widest text-xs">Indeholder:</p>
                
                <ul className="space-y-5 mb-10 border-t border-gray-200 pt-8">
                  {service.features.map((item, i) => (
                    <li key={i} className="flex gap-4">
                      <div className="w-10 h-10 rounded-full bg-[#081f32]/5 flex items-center justify-center flex-shrink-0">
                        <CheckCircle2 className="text-[#081f32]" size={18} />
                      </div>
                      <p className="font-light text-[#081f32]">{item}</p>
                    </li>
                  ))}
                </ul>

                <Link to="/kontakt" className="block w-full bg-[#081f32] text-white py-4 rounded-xl text-center text-xs font-light uppercase tracking-widest hover:bg-[#112d4a] transition-colors shadow-lg">
                  Hør mere om ledige datoer
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Konfirmation;
